import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveDirective as _resolveDirective, vModelText as _vModelText, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card-body pb-5" }
const _hoisted_2 = {
  id: "kt_customer_view_statement_tab_content",
  class: "tab-content"
}
const _hoisted_3 = {
  id: "kt_customer_view_statement_1",
  class: "py-0 tab-pane fade active show reg-list-styled umt-table umt-form",
  role: "tabpanel"
}
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center justify-content-between gap-3 mb-4 pb-2 border-bottom border-gray-200 flex-wrap\"><div class=\"umt-section-hdr fs-6 text-uppercase flex-shrink-0\">Hồ sơ đăng ký xét tuyển</div><div class=\"text-muted fs-8 fst-italic text-end\"><i class=\"bi bi-info-circle me-1\"></i>Bấm vào ô <span class=\"fw-semibold\">Tình trạng</span> để thay đổi trạng thái hồ sơ (hồ sơ đã thẩm định sẽ bị khóa). </div></div>", 1)
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "position-absolute bottom-0 mb-6 end-0 badge badge-light-info" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "badge badge-light-success ms-1"
}
const _hoisted_11 = {
  key: 1,
  class: "badge badge-light-danger ms-1"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "badge badge-light-success ms-1"
}
const _hoisted_14 = {
  key: 1,
  class: "badge badge-light-danger ms-1"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = ["title", "onClick"]
const _hoisted_17 = {
  key: 0,
  class: "text-muted fs-8 mt-1 text-nowrap",
  title: "Hồ sơ đã thẩm định hợp lệ, chờ tạo quyết định ở trang Tạo danh sách trúng tuyển — bị khóa chỉnh sửa"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-lock-fill me-1" }, null, -1)
const _hoisted_19 = {
  key: 1,
  class: "text-warning fs-8 mt-1 text-nowrap fw-semibold",
  title: "Đã trúng tuyển TẠM — cấp Số/Ngày QĐ ở menu ⋮ (hoặc trang Kết quả xét tuyển sinh) để thành chính thức"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-hourglass-split me-1" }, null, -1)
const _hoisted_21 = {
  key: 1,
  class: "d-flex align-items-center justify-content-center gap-2"
}
const _hoisted_22 = { class: "svg-icon svg-icon-5 m-0" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_25 = { class: "text-center" }
const _hoisted_26 = {
  key: 0,
  class: "form-check form-switch form-check-custom form-check-solid d-inline-flex flex-stack text-center m-auto"
}
const _hoisted_27 = ["onUpdate:modelValue", "checked", "onClick"]
const _hoisted_28 = {
  key: 1,
  class: "form-check form-switch form-check-custom form-check-solid d-inline-flex flex-stack text-center disabled m-auto"
}
const _hoisted_29 = ["onUpdate:modelValue", "checked"]
const _hoisted_30 = {
  key: 0,
  class: "d-flex align-items-center justify-content-end gap-1"
}
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye fs-4" }, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = {
  href: "#",
  class: "btn btn-sm btn-icon btn-light btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end",
  title: "Thêm thao tác"
}
const _hoisted_35 = {
  class: "svg-icon svg-icon-3 m-0",
  style: {"transform":"rotate(90deg)"}
}
const _hoisted_36 = {
  class: "menu menu-sub menu-sub-dropdown w-200px py-2 menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold dropdown-menu",
  "data-kt-menu": "true"
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "menu-link px-3 py-2 text-gray-800 fw-semibold" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-printer fs-5 me-3 text-primary" }),
  /*#__PURE__*/_createTextVNode("In phiếu ĐKXT ")
], -1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "menu-link px-3 py-2 text-gray-800 fw-semibold" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-envelope fs-5 me-3 text-info" }),
  /*#__PURE__*/_createTextVNode("Gửi mail phiếu ĐKXT ")
], -1)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { class: "menu-item" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-download fs-5 me-3 text-primary" }, null, -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-1" }, null, -1)
const _hoisted_47 = ["onClick"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", { class: "menu-link px-3 py-2 text-gray-800 fw-semibold" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-award fs-5 me-3 text-success" }),
  /*#__PURE__*/_createTextVNode("Đăng ký học bổng ")
], -1)
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = ["onClick"]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-1" }, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", { class: "menu-link px-3 py-2 text-gray-800 fw-semibold" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-patch-check-fill fs-5 me-3 text-success" }),
  /*#__PURE__*/_createTextVNode("Cấp QĐ trúng tuyển ")
], -1)
const _hoisted_53 = [
  _hoisted_51,
  _hoisted_52
]
const _hoisted_54 = ["onClick"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-1" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", { class: "menu-link px-3 py-2 text-gray-800 fw-semibold" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-calculator fs-5 me-3 text-warning" }),
  /*#__PURE__*/_createTextVNode("Cập nhật điểm (lệch Bộ) ")
], -1)
const _hoisted_57 = [
  _hoisted_55,
  _hoisted_56
]
const _hoisted_58 = ["onClick"]
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-1" }, null, -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", { class: "menu-link px-3 py-2 fw-semibold" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-octagon fs-5 me-3 text-danger" }),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "Thu hồi QĐ trúng tuyển")
], -1)
const _hoisted_61 = [
  _hoisted_59,
  _hoisted_60
]
const _hoisted_62 = {
  key: 1,
  class: "d-flex align-items-center justify-content-end gap-1"
}
const _hoisted_63 = ["onClick"]
const _hoisted_64 = { class: "svg-icon svg-icon-5 m-0" }
const _hoisted_65 = {
  href: "#",
  class: "btn btn-sm btn-icon btn-light btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end",
  title: "Thêm thao tác"
}
const _hoisted_66 = {
  class: "svg-icon svg-icon-3 m-0",
  style: {"transform":"rotate(90deg)"}
}
const _hoisted_67 = {
  class: "menu menu-sub menu-sub-dropdown w-200px py-2 menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold dropdown-menu",
  "data-kt-menu": "true"
}
const _hoisted_68 = ["onClick"]
const _hoisted_69 = /*#__PURE__*/_createElementVNode("span", { class: "menu-link px-3 py-2 text-gray-800 fw-semibold" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-printer fs-5 me-3 text-primary" }),
  /*#__PURE__*/_createTextVNode("In phiếu ĐKXT ")
], -1)
const _hoisted_70 = [
  _hoisted_69
]
const _hoisted_71 = ["onClick"]
const _hoisted_72 = /*#__PURE__*/_createElementVNode("span", { class: "menu-link px-3 py-2 text-gray-800 fw-semibold" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-envelope fs-5 me-3 text-info" }),
  /*#__PURE__*/_createTextVNode("Gửi mail phiếu ĐKXT ")
], -1)
const _hoisted_73 = [
  _hoisted_72
]
const _hoisted_74 = { class: "menu-item" }
const _hoisted_75 = ["onClick"]
const _hoisted_76 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-download fs-5 me-3 text-primary" }, null, -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-1" }, null, -1)
const _hoisted_78 = ["onClick"]
const _hoisted_79 = /*#__PURE__*/_createElementVNode("span", { class: "menu-link px-3 py-2 text-gray-800 fw-semibold" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-award fs-5 me-3 text-success" }),
  /*#__PURE__*/_createTextVNode("Đăng ký học bổng ")
], -1)
const _hoisted_80 = [
  _hoisted_79
]
const _hoisted_81 = ["onClick"]
const _hoisted_82 = /*#__PURE__*/_createElementVNode("span", { class: "menu-link px-3 py-2 text-gray-800 fw-semibold" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-patch-check fs-5 me-3 text-success" }),
  /*#__PURE__*/_createTextVNode("Xét trúng tuyển ")
], -1)
const _hoisted_83 = [
  _hoisted_82
]
const _hoisted_84 = { class: "menu-item" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-1" }, null, -1)
const _hoisted_86 = ["onClick"]
const _hoisted_87 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash fs-5 me-3 text-danger" }, null, -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "Xóa hồ sơ", -1)
const _hoisted_89 = [
  _hoisted_87,
  _hoisted_88
]
const _hoisted_90 = {
  key: 0,
  class: "px-2",
  style: {"max-height":"calc(100vh - 3rem)","overflow-y":"auto","overflow-x":"hidden"}
}
const _hoisted_91 = { class: "d-flex align-items-start justify-content-between mb-3" }
const _hoisted_92 = { class: "pe-3" }
const _hoisted_93 = { class: "fs-4 fw-bold text-gray-900" }
const _hoisted_94 = { class: "text-muted fs-7" }
const _hoisted_95 = { key: 0 }
const _hoisted_96 = { class: "fw-semibold text-gray-700" }
const _hoisted_97 = { key: 1 }
const _hoisted_98 = { class: "fw-semibold text-gray-700" }
const _hoisted_99 = { class: "svg-icon svg-icon-2 m-0" }
const _hoisted_100 = { class: "d-flex flex-wrap gap-2 mb-5" }
const _hoisted_101 = {
  key: 0,
  class: "badge badge-light-dark"
}
const _hoisted_102 = { class: "border border-gray-300 border-dashed rounded p-4 mb-4" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder text-gray-800 mb-3" }, "Thông tin hồ sơ", -1)
const _hoisted_104 = { class: "row g-3" }
const _hoisted_105 = { class: "col-4" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Mã hồ sơ", -1)
const _hoisted_107 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_108 = { class: "col-4" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Đợt", -1)
const _hoisted_110 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_111 = { class: "col-4" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Phương thức", -1)
const _hoisted_113 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_114 = { class: "col-4" }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Nguồn", -1)
const _hoisted_116 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_117 = { class: "col-4" }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Ngày tạo", -1)
const _hoisted_119 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_120 = {
  key: 0,
  class: "col-4"
}
const _hoisted_121 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Cập nhật", -1)
const _hoisted_122 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_123 = { class: "border border-gray-300 border-dashed rounded p-4 mb-4" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder text-gray-800 mb-3" }, "Ngành đăng ký", -1)
const _hoisted_125 = {
  key: 0,
  class: "text-muted fs-7"
}
const _hoisted_126 = {
  key: 1,
  class: "d-flex flex-column gap-3"
}
const _hoisted_127 = {
  class: "badge badge-circle badge-light-primary me-2",
  title: "Ưu tiên"
}
const _hoisted_128 = { class: "flex-grow-1" }
const _hoisted_129 = { class: "d-flex justify-content-between align-items-center gap-2" }
const _hoisted_130 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_131 = {
  key: 0,
  class: "badge badge-light-success fs-8 text-nowrap",
  title: "Tổng điểm xét tuyển"
}
const _hoisted_132 = { class: "text-muted fs-8" }
const _hoisted_133 = { key: 0 }
const _hoisted_134 = { key: 1 }
const _hoisted_135 = { key: 2 }
const _hoisted_136 = {
  key: 3,
  class: "text-success fw-semibold"
}
const _hoisted_137 = {
  key: 2,
  class: "row g-3"
}
const _hoisted_138 = {
  key: 3,
  class: "d-flex align-items-start"
}
const _hoisted_139 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge badge-circle badge-light-primary me-2",
  title: "Ưu tiên"
}, "1", -1)
const _hoisted_140 = { class: "flex-grow-1" }
const _hoisted_141 = { class: "d-flex justify-content-between align-items-center gap-2" }
const _hoisted_142 = { class: "text-gray-900 fw-semibold fs-7" }
const _hoisted_143 = {
  key: 0,
  class: "badge badge-light-success fs-8 text-nowrap",
  title: "Điểm xét (hệ 10)"
}
const _hoisted_144 = { class: "text-muted fs-8" }
const _hoisted_145 = { key: 0 }
const _hoisted_146 = {
  key: 4,
  class: "text-muted"
}
const _hoisted_147 = {
  key: 0,
  class: "border border-gray-300 border-dashed rounded p-4 mb-4"
}
const _hoisted_148 = { class: "fw-bolder text-gray-800 mb-3 d-flex align-items-center justify-content-between" }
const _hoisted_149 = /*#__PURE__*/_createElementVNode("span", null, "Điểm xét tuyển", -1)
const _hoisted_150 = {
  key: 0,
  class: "badge badge-light-primary fs-8"
}
const _hoisted_151 = {
  key: 0,
  class: "d-flex align-items-start bg-light-danger border border-danger border-dashed rounded p-3 mb-3"
}
const _hoisted_152 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger fw-semibold fs-8" }, [
  /*#__PURE__*/_createTextVNode("⚠ Phương pháp Học bạ không hợp lệ cho 2026 (chỉ nhận "),
  /*#__PURE__*/_createElementVNode("b", null, "9CR"),
  /*#__PURE__*/_createTextVNode(") — hồ sơ bị tính KHÔNG hợp lệ, cần chỉnh lại phương pháp xét tuyển.")
], -1)
const _hoisted_153 = [
  _hoisted_152
]
const _hoisted_154 = {
  key: 0,
  class: "text-gray-500 fs-8 fw-semibold text-uppercase mb-1"
}
const _hoisted_155 = { class: "row g-2" }
const _hoisted_156 = { class: "text-gray-600 fs-8" }
const _hoisted_157 = { class: "text-gray-900 fw-semibold fs-8 ms-2 text-end" }
const _hoisted_158 = {
  key: 2,
  class: "text-muted fs-8"
}
const _hoisted_159 = { class: "border border-gray-300 border-dashed rounded p-4 mb-2" }
const _hoisted_160 = { class: "fw-bolder text-gray-800 mb-3 d-flex align-items-center justify-content-between" }
const _hoisted_161 = /*#__PURE__*/_createElementVNode("span", null, "Salesforce", -1)
const _hoisted_162 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_163 = {
  key: 1,
  class: "badge badge-light-warning"
}
const _hoisted_164 = {
  key: 2,
  class: "badge badge-light-secondary"
}
const _hoisted_165 = {
  key: 0,
  class: "row g-2 mb-1"
}
const _hoisted_166 = {
  key: 0,
  class: "col-6"
}
const _hoisted_167 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Lead", -1)
const _hoisted_168 = ["href"]
const _hoisted_169 = {
  key: 1,
  class: "col-6"
}
const _hoisted_170 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Opportunity", -1)
const _hoisted_171 = ["href"]
const _hoisted_172 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_173 = { class: "row g-2" }
const _hoisted_174 = { class: "text-gray-600 fs-8" }
const _hoisted_175 = { class: "text-muted" }
const _hoisted_176 = { class: "text-gray-900 fw-semibold fs-8 text-break" }
const _hoisted_177 = {
  key: 1,
  class: "text-muted fs-8 mt-3"
}
const _hoisted_178 = {
  type: "button",
  class: "btn btn-success me-3 d-none",
  ref: "call_auth_rejected",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_auth_rejected"
}
const _hoisted_179 = {
  class: "modal fade",
  id: "kt_modal_auth_rejected",
  ref: "addAuthRejectedModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_180 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_181 = { class: "modal-content" }
const _hoisted_182 = {
  class: "modal-header p-3",
  id: "kt_modal_add_customer_header"
}
const _hoisted_183 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Xác thực trạng thái không hợp lệ", -1)
const _hoisted_184 = {
  id: "kt_modal_add_customer_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_185 = { class: "svg-icon svg-icon-1" }
const _hoisted_186 = { class: "modal-body py-4 px-lg-6" }
const _hoisted_187 = { class: "d-flex gap-5 mb-3" }
const _hoisted_188 = { class: "fv-row flex-md-root" }
const _hoisted_189 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Lý do", -1)
const _hoisted_190 = { class: "w-100 text-center" }
const _hoisted_191 = {
  type: "button",
  class: "d-none",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_reg_scholarship",
  ref: "regSchTrigger"
}
const _hoisted_192 = {
  class: "modal fade umt-form",
  id: "kt_modal_reg_scholarship",
  ref: "regSchModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_193 = { class: "modal-dialog modal-dialog-centered mw-550px" }
const _hoisted_194 = { class: "modal-content" }
const _hoisted_195 = { class: "modal-header p-3" }
const _hoisted_196 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Đăng ký học bổng", -1)
const _hoisted_197 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_198 = { class: "svg-icon svg-icon-1" }
const _hoisted_199 = { class: "modal-body py-4 px-lg-6" }
const _hoisted_200 = { class: "notice bg-light-primary rounded border-primary border border-dashed p-3 mb-4 fs-7 text-gray-800" }
const _hoisted_201 = /*#__PURE__*/_createElementVNode("b", null, "Mới", -1)
const _hoisted_202 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required fw-bolder" }, "Học bổng đăng ký", -1)
const _hoisted_203 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required fw-bolder mt-4" }, "Ngành nhận học bổng", -1)
const _hoisted_204 = {
  key: 0,
  class: "text-danger fs-8 mt-1"
}
const _hoisted_205 = { class: "modal-footer py-3 px-lg-6" }
const _hoisted_206 = /*#__PURE__*/_createElementVNode("span", {
  class: "btn btn-light umt-btn-32",
  "data-bs-dismiss": "modal"
}, "Hủy bỏ", -1)
const _hoisted_207 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_RescoreDrawer = _resolveComponent("RescoreDrawer")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_ModalDeleteAndReason = _resolveComponent("ModalDeleteAndReason")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: _normalizeClass(`card ${_ctx.cardClasses}`)
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_Datatable, {
              "table-header": _ctx.tableHeader,
              "table-data": _ctx.tableData,
              "rows-per-page": 25,
              "enable-items-per-page-dropdown": false,
              classTable: "table-row-bordered"
            }, {
              "cell-code": _withCtx(({ row: customer }) => [
                _createElementVNode("div", {
                  class: "cursor-pointer position-relative text-primary fw-bold",
                  onClick: ($event: any) => (_ctx.openQuickView(customer))
                }, [
                  _createTextVNode(_toDisplayString(customer.code) + " ", 1),
                  _createElementVNode("span", _hoisted_6, "Đợt " + _toDisplayString(customer.phase), 1)
                ], 8, _hoisted_5)
              ]),
              "cell-method": _withCtx(({ row: customer }) => [
                _createElementVNode("div", {
                  class: "cursor-pointer",
                  onClick: ($event: any) => (_ctx.editAdmission(customer))
                }, _toDisplayString(customer.method), 9, _hoisted_7)
              ]),
              "cell-source": _withCtx(({ row: customer }) => [
                _createElementVNode("div", {
                  onClick: ($event: any) => (_ctx.editAdmission(customer)),
                  class: _normalizeClass(`cursor-pointer text-center text-${_ctx.arrResource[customer.source]?_ctx.arrResource[customer.source]?.state:'info'}`)
                }, _toDisplayString(_ctx.arrResource[customer.source]?_ctx.arrResource[customer.source]?.label:customer.source), 11, _hoisted_8)
              ]),
              "cell-majors": _withCtx(({ row: customer }) => [
                _createElementVNode("div", {
                  class: "cursor-pointer",
                  onClick: ($event: any) => (_ctx.editAdmission(customer))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customer.majors, (item, index) => {
                    return (_openBlock(), _createElementBlock("span", { key: index }, [
                      (customer.status?.value == 'passed')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (item.passed!=null || customer.idAdMethod == 9)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString('- '+item.name) + " ", 1),
                                  (item.averageScore)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(item.adForm), 1))
                                    : _createCommentVNode("", true),
                                  (item.averageScore)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(item.averageScore), 1))
                                    : _createCommentVNode("", true),
                                  _hoisted_12
                                ], 64))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString('- '+item.name) + " ", 1),
                            (item.averageScore)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(item.adForm), 1))
                              : _createCommentVNode("", true),
                            (item.averageScore)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(item.averageScore), 1))
                              : _createCommentVNode("", true),
                            _hoisted_15
                          ], 64))
                    ]))
                  }), 128))
                ], 8, _hoisted_9)
              ]),
              "cell-status": _withCtx(({ row: customer }) => [
                (_ctx.editingStatusId !== customer.id)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["text-center", _ctx.canEditStatus(customer) ? 'cursor-pointer' : '']),
                      title: _ctx.canEditStatus(customer) ? 'Bấm để cập nhật trạng thái' : (customer.isAppraised ? 'Hồ sơ đã thẩm định — khoá' : 'Bạn không có quyền đổi trạng thái'),
                      onClick: ($event: any) => (_ctx.canEditStatus(customer) ? _ctx.editUpdateStatus(customer) : null)
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(` m-auto badge badge-light-${customer.status.state}`)
                      }, _toDisplayString(customer.status.label), 3),
                      (customer.isAppraised && customer.status?.value !== 'passed' && customer.status?.value !== 'failed')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _hoisted_18,
                            _createTextVNode("Chờ QĐ trúng tuyển ")
                          ]))
                        : _createCommentVNode("", true),
                      (customer.status?.value === 'passed' && !customer.winnerDecisionCode)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _hoisted_20,
                            _createTextVNode("Chờ cấp số QĐ ")
                          ]))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_16))
                  : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createVNode(_component_el_select, {
                        class: "w-150px",
                        placeholder: "Chọn trạng thái",
                        modelValue: _ctx.statusRecord,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.statusRecord) = $event)),
                        onChange: ($event: any) => (_ctx.updateStatusAdmission(customer))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Mới",
                            value: "new"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Mới")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Đã xác thực",
                            value: "verified"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Đã xác thực")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Chưa hoàn tất",
                            value: "processing"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Chưa hoàn tất")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Đang xem xét",
                            value: "reviewing"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Đang xem xét")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Không hợp lệ",
                            value: "rejected"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Không hợp lệ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Từ chối",
                            value: "denied"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Từ chối")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onChange"]),
                      _createElementVNode("span", {
                        class: "btn btn-sm btn-icon btn-light",
                        title: "Hủy",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editingStatusId = null))
                      }, [
                        _createElementVNode("span", _hoisted_22, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                        ])
                      ])
                    ]))
              ]),
              "cell-date": _withCtx(({ row: customer }) => [
                _createElementVNode("div", {
                  onClick: ($event: any) => (_ctx.editAdmission(customer)),
                  class: "cursor-pointer text-center"
                }, [
                  _createElementVNode("div", null, _toDisplayString(customer.date), 1),
                  (customer.updatedAt && customer.updatedAt != customer.date)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, "Sửa: " + _toDisplayString(customer.updatedAt), 1))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_23)
              ]),
              "cell-isActive": _withCtx(({ row: customer }) => [
                _createElementVNode("div", _hoisted_25, [
                  (_ctx.checkPermission([_ctx.Permission.ADMISSION_REGISTER_EDIT_STATUS,_ctx.Permission.ADMISSION_REGISTER]) && !customer.isAppraised)
                    ? (_openBlock(), _createElementBlock("label", _hoisted_26, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          "onUpdate:modelValue": ($event: any) => ((customer.isActive) = $event),
                          checked: customer.isActive,
                          onClick: ($event: any) => (_ctx.activatedRegisterChange($event.target.checked,customer))
                        }, null, 8, _hoisted_27), [
                          [_vModelCheckbox, customer.isActive]
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("label", _hoisted_28, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          "onUpdate:modelValue": ($event: any) => ((customer.isActive) = $event),
                          checked: customer.isActive
                        }, null, 8, _hoisted_29), [
                          [_vModelCheckbox, customer.isActive]
                        ])
                      ]))
                ])
              ]),
              "cell-actions": _withCtx(({ row: customer }) => [
                (customer.isAppraised)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-sm btn-icon btn-light btn-active-light-primary",
                        title: "Xem chi tiết hồ sơ",
                        onClick: ($event: any) => (_ctx.editAdmission(customer))
                      }, _hoisted_33, 8, _hoisted_31),
                      _createElementVNode("a", _hoisted_34, [
                        _createElementVNode("span", _hoisted_35, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen052.svg" })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        (customer.idAdMethod != 9)
                          ? _withDirectives((_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "menu-item",
                              onClick: ($event: any) => (_ctx.getPdf(customer))
                            }, _hoisted_39, 8, _hoisted_37)), [
                              [_directive_permission, [_ctx.Permission.ADMISSION_REGISTER_PRINT,_ctx.Permission.ADMISSION_REGISTER]]
                            ])
                          : _createCommentVNode("", true),
                        (customer.idAdMethod != 9)
                          ? _withDirectives((_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "menu-item",
                              onClick: ($event: any) => (_ctx.sendMail(customer))
                            }, _hoisted_42, 8, _hoisted_40)), [
                              [_directive_permission, [_ctx.Permission.ADMISSION_REGISTER_EMAIL,_ctx.Permission.ADMISSION_REGISTER]]
                            ])
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_43, [
                          (_ctx.checkPermission([_ctx.Permission.ADMISSION_REGISTER_DOWNLOAD,_ctx.Permission.ADMISSION_REGISTER]))
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                onClick: ($event: any) => (_ctx.downloadAdmission(customer)),
                                class: "menu-link px-3 py-2 text-gray-800 fw-semibold"
                              }, [
                                _hoisted_45,
                                _createTextVNode("Tải hồ sơ ")
                              ], 8, _hoisted_44))
                            : _createCommentVNode("", true)
                        ]),
                        _hoisted_46,
                        _createElementVNode("div", {
                          class: "menu-item",
                          onClick: ($event: any) => (_ctx.openScholarshipReg(customer))
                        }, _hoisted_49, 8, _hoisted_47),
                        (customer.status?.value == 'passed' && !customer.winnerDecisionCode && customer.idAdMethod != 9)
                          ? _withDirectives((_openBlock(), _createElementBlock("div", {
                              key: 2,
                              class: "menu-item",
                              onClick: ($event: any) => (_ctx.confirmDecision(customer))
                            }, _hoisted_53, 8, _hoisted_50)), [
                              [_directive_permission, [_ctx.Permission.ADMISSION_REGISTER_EDIT_STATUS, _ctx.Permission.ADMISSION_REGISTER]]
                            ])
                          : _createCommentVNode("", true),
                        (customer.status?.value == 'passed' && [1, 4].includes(+customer.idAdMethod))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 3,
                              class: "menu-item",
                              onClick: ($event: any) => (_ctx.openRescore(customer))
                            }, _hoisted_57, 8, _hoisted_54))
                          : _createCommentVNode("", true),
                        (customer.status?.value == 'passed' && customer.winnerDecisionCode && customer.winnerId)
                          ? _withDirectives((_openBlock(), _createElementBlock("div", {
                              key: 4,
                              class: "menu-item",
                              onClick: ($event: any) => (_ctx.revokeWinner(customer))
                            }, _hoisted_61, 8, _hoisted_58)), [
                              [_directive_permission, [_ctx.Permission.ADMISSION_REGISTER_EDIT_STATUS, _ctx.Permission.ADMISSION_REGISTER]]
                            ])
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_62, [
                      _withDirectives((_openBlock(), _createElementBlock("button", {
                        type: "button",
                        class: "btn btn-sm btn-icon btn-light btn-active-light-primary",
                        title: "Chỉnh sửa",
                        onClick: ($event: any) => (_ctx.editAdmission(customer))
                      }, [
                        _createElementVNode("span", _hoisted_64, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                        ])
                      ], 8, _hoisted_63)), [
                        [_directive_permission, [_ctx.Permission.ADMISSION_REGISTER_EDIT,_ctx.Permission.ADMISSION_REGISTER]]
                      ]),
                      _createElementVNode("a", _hoisted_65, [
                        _createElementVNode("span", _hoisted_66, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen052.svg" })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_67, [
                        (customer.idAdMethod != 9)
                          ? _withDirectives((_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "menu-item",
                              onClick: ($event: any) => (_ctx.getPdf(customer))
                            }, _hoisted_70, 8, _hoisted_68)), [
                              [_directive_permission, [_ctx.Permission.ADMISSION_REGISTER_PRINT,_ctx.Permission.ADMISSION_REGISTER]]
                            ])
                          : _createCommentVNode("", true),
                        (customer.idAdMethod != 9)
                          ? _withDirectives((_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "menu-item",
                              onClick: ($event: any) => (_ctx.sendMail(customer))
                            }, _hoisted_73, 8, _hoisted_71)), [
                              [_directive_permission, [_ctx.Permission.ADMISSION_REGISTER_EMAIL,_ctx.Permission.ADMISSION_REGISTER]]
                            ])
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_74, [
                          (_ctx.checkPermission([_ctx.Permission.ADMISSION_REGISTER_DOWNLOAD,_ctx.Permission.ADMISSION_REGISTER]))
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                onClick: ($event: any) => (_ctx.downloadAdmission(customer)),
                                class: "menu-link px-3 py-2 text-gray-800 fw-semibold"
                              }, [
                                _hoisted_76,
                                _createTextVNode("Tải hồ sơ ")
                              ], 8, _hoisted_75))
                            : _createCommentVNode("", true)
                        ]),
                        _hoisted_77,
                        _createElementVNode("div", {
                          class: "menu-item",
                          onClick: ($event: any) => (_ctx.openScholarshipReg(customer))
                        }, _hoisted_80, 8, _hoisted_78),
                        (customer.status?.value == 'verified' && customer.idAdMethod != 9)
                          ? _withDirectives((_openBlock(), _createElementBlock("div", {
                              key: 2,
                              class: "menu-item",
                              onClick: ($event: any) => (_ctx.appraiseProfile(customer))
                            }, _hoisted_83, 8, _hoisted_81)), [
                              [_directive_permission, [_ctx.Permission.ADMISSION_REGISTER_EDIT_STATUS,_ctx.Permission.ADMISSION_REGISTER]]
                            ])
                          : _createCommentVNode("", true),
                        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_84, [
                          _hoisted_85,
                          _createElementVNode("a", {
                            class: "menu-link px-3 py-2 fw-semibold",
                            onClick: ($event: any) => (_ctx.callModalDelete(customer))
                          }, _hoisted_89, 8, _hoisted_86)
                        ])), [
                          [_directive_permission, [_ctx.Permission.ADMISSION_REGISTER_DELETE,_ctx.Permission.ADMISSION_REGISTER]]
                        ])
                      ])
                    ]))
              ]),
              _: 1
            }, 8, ["table-header", "table-data"])
          ])
        ])
      ])
    ], 2)), [
      [_directive_permission, [_ctx.Permission.ADMISSION_REGISTER_VIEW,_ctx.Permission.ADMISSION_REGISTER]]
    ]),
    _createVNode(_component_RescoreDrawer, {
      ref: "rescoreDrawer",
      onSaved: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('reload')))
    }, null, 512),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.drawerVisible,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.drawerVisible) = $event)),
      direction: "rtl",
      size: "500px",
      "with-header": false
    }, {
      default: _withCtx(() => [
        (_ctx.drawerRow)
          ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
              _createElementVNode("div", _hoisted_91, [
                _createElementVNode("div", _hoisted_92, [
                  _createElementVNode("div", _hoisted_93, _toDisplayString((_ctx.dataCustomer && _ctx.dataCustomer.fullName) || 'Ứng viên'), 1),
                  _createElementVNode("div", _hoisted_94, [
                    (_ctx.dataCustomer && _ctx.dataCustomer.idCard)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_95, [
                          _createTextVNode("CCCD: "),
                          _createElementVNode("span", _hoisted_96, _toDisplayString(_ctx.dataCustomer.idCard), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.drawerRow.code)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_97, [
                          _createTextVNode(" · Mã HS: "),
                          _createElementVNode("span", _hoisted_98, _toDisplayString(_ctx.drawerRow.code), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("span", {
                  class: "btn btn-sm btn-icon btn-active-light-primary",
                  title: "Đóng",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.drawerVisible = false))
                }, [
                  _createElementVNode("span", _hoisted_99, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_100, [
                _createElementVNode("span", {
                  class: _normalizeClass(`badge badge-light-${_ctx.drawerRow.status?.state}`)
                }, _toDisplayString(_ctx.drawerRow.status?.label), 3),
                _createElementVNode("span", {
                  class: _normalizeClass(`badge badge-light-${_ctx.drawerRow.isActive ? 'success' : 'secondary'}`)
                }, _toDisplayString(_ctx.drawerRow.isActive ? 'Đang kích hoạt' : 'Đã tắt'), 3),
                (_ctx.drawerRow.isAppraised)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_101, "Đã thẩm định"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_102, [
                _hoisted_103,
                _createElementVNode("div", _hoisted_104, [
                  _createElementVNode("div", _hoisted_105, [
                    _hoisted_106,
                    _createElementVNode("div", _hoisted_107, _toDisplayString(_ctx.drawerRow.code || '—'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_108, [
                    _hoisted_109,
                    _createElementVNode("div", _hoisted_110, _toDisplayString(_ctx.drawerRow.phase || '—'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_111, [
                    _hoisted_112,
                    _createElementVNode("div", _hoisted_113, _toDisplayString(_ctx.methodLabelFull()), 1)
                  ]),
                  _createElementVNode("div", _hoisted_114, [
                    _hoisted_115,
                    _createElementVNode("div", _hoisted_116, _toDisplayString(_ctx.arrResource[_ctx.drawerRow.source] ? _ctx.arrResource[_ctx.drawerRow.source].label : (_ctx.drawerRow.source || '—')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_117, [
                    _hoisted_118,
                    _createElementVNode("div", _hoisted_119, _toDisplayString(_ctx.drawerRow.date || '—'), 1)
                  ]),
                  (_ctx.drawerDetail && _ctx.drawerDetail.adRegister && _ctx.drawerDetail.adRegister.updatedAtText)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                        _hoisted_121,
                        _createElementVNode("div", _hoisted_122, _toDisplayString(_ctx.drawerDetail.adRegister.updatedAtText), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_123, [
                _hoisted_124,
                (_ctx.drawerLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_125, "Đang tải…"))
                  : (_ctx.drawerDetail && _ctx.drawerDetail.adMajors && _ctx.drawerDetail.adMajors.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.drawerDetail.adMajors, (m, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "d-flex align-items-start",
                            key: i
                          }, [
                            _createElementVNode("span", _hoisted_127, _toDisplayString(m.priority || (i + 1)), 1),
                            _createElementVNode("div", _hoisted_128, [
                              _createElementVNode("div", _hoisted_129, [
                                _createElementVNode("div", _hoisted_130, _toDisplayString((m.major && m.major.name) || m.name || '—'), 1),
                                (m.averageScore != null && m.averageScore !== '')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_131, _toDisplayString(m.averageScore) + " điểm", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_132, [
                                (m.major && m.major.code)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_133, "Mã " + _toDisplayString(m.major.code), 1))
                                  : _createCommentVNode("", true),
                                (m.adForm)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_134, " · Tổ hợp " + _toDisplayString(m.adForm), 1))
                                  : _createCommentVNode("", true),
                                (m.subadform)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_135, " (" + _toDisplayString(m.subadform) + ")", 1))
                                  : _createCommentVNode("", true),
                                (Number(m.priorityScore) > 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_136, " · ƯT KV/ĐT +" + _toDisplayString(m.priorityScore), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_ctx.drawerRow.majors && _ctx.drawerRow.majors.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.drawerRow.majors, (m, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "col-6 text-gray-900 fs-7",
                              key: i
                            }, _toDisplayString((i + 1) + '. ' + m.name), 1))
                          }), 128))
                        ]))
                      : (_ctx.arproMajor())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                            _hoisted_139,
                            _createElementVNode("div", _hoisted_140, [
                              _createElementVNode("div", _hoisted_141, [
                                _createElementVNode("div", _hoisted_142, _toDisplayString(_ctx.arproMajor().name), 1),
                                (_ctx.arproMajor().averageScore)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_143, _toDisplayString(_ctx.arproMajor().averageScore) + " điểm", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_144, [
                                (_ctx.arproMajor().code)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_145, "Mã " + _toDisplayString(_ctx.arproMajor().code), 1))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" · Liên thông (LTĐHCQ)")
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_146, "—"))
              ]),
              (_ctx.drawerDetail && _ctx.drawerDetail.adRegister)
                ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
                    _createElementVNode("div", _hoisted_148, [
                      _hoisted_149,
                      (_ctx.scoreMethodLabel())
                        ? (_openBlock(), _createElementBlock("span", _hoisted_150, _toDisplayString(_ctx.scoreMethodLabel()), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.hocbaVariantInvalid())
                      ? (_openBlock(), _createElementBlock("div", _hoisted_151, _hoisted_153))
                      : _createCommentVNode("", true),
                    (_ctx.scoreGroups().length)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.scoreGroups(), (g, gi) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: gi,
                            class: "mb-3"
                          }, [
                            (g.title)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_154, _toDisplayString(g.title), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_155, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.rows, (r, ri) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: _normalizeClass([g.wide ? 'col-12' : 'col-6', "d-flex justify-content-between"]),
                                  key: ri
                                }, [
                                  _createElementVNode("span", _hoisted_156, _toDisplayString(r.label), 1),
                                  _createElementVNode("span", _hoisted_157, _toDisplayString(r.value), 1)
                                ], 2))
                              }), 128))
                            ])
                          ]))
                        }), 128))
                      : (_openBlock(), _createElementBlock("div", _hoisted_158, "Chưa nhập điểm xét tuyển cho hồ sơ này."))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_159, [
                _createElementVNode("div", _hoisted_160, [
                  _hoisted_161,
                  (_ctx.dataCustomer && _ctx.dataCustomer.opportunityid)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_162, "Đã đẩy · Opportunity"))
                    : (_ctx.dataCustomer && _ctx.dataCustomer.leadid)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_163, "Đã đẩy · Lead"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_164, "Chưa đẩy"))
                ]),
                (_ctx.dataCustomer && (_ctx.dataCustomer.leadid || _ctx.dataCustomer.opportunityid))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_165, [
                      (_ctx.dataCustomer.leadid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_166, [
                            _hoisted_167,
                            _createElementVNode("a", {
                              href: `https://umthcm.lightning.force.com/lightning/r/Lead/${_ctx.dataCustomer.leadid}/view`,
                              target: "_blank",
                              class: "text-primary fw-semibold fs-8 text-break"
                            }, _toDisplayString(_ctx.dataCustomer.leadid), 9, _hoisted_168)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.dataCustomer.opportunityid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_169, [
                            _hoisted_170,
                            _createElementVNode("a", {
                              href: `https://umthcm.lightning.force.com/lightning/r/Opportunity/${_ctx.dataCustomer.opportunityid}/view`,
                              target: "_blank",
                              class: "text-primary fw-semibold fs-8 text-break"
                            }, _toDisplayString(_ctx.dataCustomer.opportunityid), 9, _hoisted_171)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_172,
                _createElementVNode("div", _hoisted_173, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sfMappedFields(), (f, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-6",
                      key: i
                    }, [
                      _createElementVNode("div", _hoisted_174, [
                        _createTextVNode(_toDisplayString(f.label) + " ", 1),
                        _createElementVNode("span", _hoisted_175, "[" + _toDisplayString(f.sf) + "]", 1)
                      ]),
                      _createElementVNode("div", _hoisted_176, _toDisplayString(f.value), 1)
                    ]))
                  }), 128))
                ]),
                (_ctx.dataCustomer && !_ctx.dataCustomer.leadid && !_ctx.dataCustomer.opportunityid)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_177, " Hồ sơ chưa được đẩy lên Salesforce (đẩy khi trạng thái chuyển sang \"Đã xác thực\" / \"Đang xem xét\"). "))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("button", _hoisted_178, null, 512),
    _createElementVNode("div", _hoisted_179, [
      _createElementVNode("div", _hoisted_180, [
        _createElementVNode("div", _hoisted_181, [
          _createElementVNode("div", _hoisted_182, [
            _hoisted_183,
            _createElementVNode("div", _hoisted_184, [
              _createElementVNode("span", _hoisted_185, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_186, [
              _createElementVNode("div", _hoisted_187, [
                _createElementVNode("div", _hoisted_188, [
                  _hoisted_189,
                  _withDirectives(_createElementVNode("textarea", {
                    name: "",
                    class: "area-custom",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.comment_profile) = $event)),
                    id: "",
                    style: {"width":"100%","height":"80px"}
                  }, null, 512), [
                    [_vModelText, _ctx.comment_profile]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_190, [
                _createElementVNode("button", {
                  class: _normalizeClass(["btn btn-success m-auto", _ctx.comment_profile ==''?'disabled':'']),
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.submitComment()))
                }, " Đồng ý ", 2)
              ])
            ])
          ])
        ])
      ])
    ], 512),
    _createVNode(_component_ModalDeleteAndReason, {
      ref: "callFunctionModal",
      title: "Xác nhận xóa hồ sơ này",
      id: "auth_delete_profile",
      onCallBackDelete: _ctx.deleteCustomer
    }, null, 8, ["onCallBackDelete"]),
    _createElementVNode("button", _hoisted_191, null, 512),
    _createElementVNode("div", _hoisted_192, [
      _createElementVNode("div", _hoisted_193, [
        _createElementVNode("div", _hoisted_194, [
          _createElementVNode("div", _hoisted_195, [
            _hoisted_196,
            _createElementVNode("div", _hoisted_197, [
              _createElementVNode("span", _hoisted_198, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_199, [
            _createElementVNode("div", _hoisted_200, [
              _createTextVNode(" Đăng ký xét học bổng cho hồ sơ "),
              _createElementVNode("b", null, _toDisplayString(_ctx.regSchRecord?.code), 1),
              _createTextVNode(" — ứng viên "),
              _createElementVNode("b", null, _toDisplayString(_ctx.dataCustomer?.fullName), 1),
              _createTextVNode(". Đăng ký tạo ở trạng thái "),
              _hoisted_201,
              _createTextVNode("; duyệt/cấp thực hiện ở khối \"Học bổng của ứng viên\" bên dưới hoặc trang Danh sách đăng ký xét học bổng. ")
            ]),
            _hoisted_202,
            _createVNode(_component_el_select, {
              class: "w-100",
              filterable: "",
              placeholder: "Chọn học bổng",
              modelValue: _ctx.regSchId,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.regSchId) = $event)),
              "popper-class": "umt-form-dd"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scholarshipCatalog, (s) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: s.id,
                    label: `${s.name} (${s.code})`,
                    value: s.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _hoisted_203,
            _createVNode(_component_el_select, {
              class: "w-100",
              placeholder: "Chọn ngành",
              modelValue: _ctx.regSchMajorId,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.regSchMajorId) = $event)),
              "popper-class": "umt-form-dd"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.regSchRecord?.majors || []), (m) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: m.id,
                    label: m.name,
                    value: m.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (_ctx.regSchError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_204, _toDisplayString(_ctx.regSchError), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_205, [
            _hoisted_206,
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary umt-btn-32",
              disabled: _ctx.regSchSaving,
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.submitScholarshipReg()))
            }, "Đăng ký", 8, _hoisted_207)
          ])
        ])
      ])
    ], 512)
  ], 64))
}